import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {OrderContext} from '../order-context'

const PricingDetails = ({order}) => {
    const {activeReturnShipmentId} = useContext(OrderContext)
    const styles = useMultiStyleConfig('Orders', {
        isReturnFlow: !!activeReturnShipmentId,
    })

    const {currency: localCurrency} = useCurrency()
    const currency = order?.orderItems?.[0]?.CurrencyIsoCode || localCurrency

    if (!order) return

    return (
        <Flex {...styles.priceContainer}>
            {!activeReturnShipmentId && (
                <>
                    <Flex {...styles.priceChild}>
                        <Text {...styles.priceTitle}>
                            <FormattedMessage
                                defaultMessage="Subtotal"
                                id="account_order_detail.label.subtotal"
                            />
                        </Text>
                        <Text {...styles.priceNumber}>
                            {currency && order?.subTotal && (
                                <FormattedNumber
                                    style="currency"
                                    currency={currency}
                                    value={order?.subTotal}
                                    currencyDisplay="narrowSymbol"
                                />
                            )}
                        </Text>
                    </Flex>
                    <Flex {...styles.priceChild}>
                        <Text {...styles.priceTitle}>
                            <FormattedMessage
                                defaultMessage="Discount"
                                id="account_order_detail.label.discount"
                            />
                        </Text>
                        <Text {...styles.priceNumber}>
                            {currency && order?.totalDiscount && (
                                <FormattedNumber
                                    style="currency"
                                    currency={currency}
                                    value={order?.totalDiscount}
                                    currencyDisplay="narrowSymbol"
                                />
                            )}
                        </Text>
                    </Flex>
                    <Flex {...styles.priceChild}>
                        <Text {...styles.priceTitle}>
                            <FormattedMessage
                                defaultMessage="Shipping cost"
                                id="account_order_detail.label.shipping_cost"
                            />
                        </Text>
                        <Text {...styles.priceNumber}>
                            {currency && order?.shippingCost && (
                                <FormattedNumber
                                    style="currency"
                                    currency={currency}
                                    value={order?.shippingCost}
                                    currencyDisplay="narrowSymbol"
                                />
                            )}
                        </Text>
                    </Flex>
                    <Flex {...styles.priceChild}>
                        <Text {...styles.priceTitle}>
                            <FormattedMessage
                                defaultMessage="Taxes"
                                id="account_order_detail.label.taxes"
                            />
                        </Text>
                        <Text {...styles.priceNumber}>
                            {currency && order?.totalTax && (
                                <FormattedNumber
                                    style="currency"
                                    currency={currency}
                                    value={order?.totalTax}
                                    currencyDisplay="narrowSymbol"
                                />
                            )}
                        </Text>
                    </Flex>
                </>
            )}

            <Flex {...styles.priceChild}>
                <Text {...styles.priceTitle}>
                    <FormattedMessage
                        defaultMessage="Total"
                        id="account_order_detail.label.total"
                    />
                </Text>
                <Text {...styles.priceNumber}>
                    {currency && order?.totalAmount && (
                        <FormattedNumber
                            style="currency"
                            currency={currency}
                            value={order?.totalAmount}
                            currencyDisplay="narrowSymbol"
                        />
                    )}
                </Text>
            </Flex>
        </Flex>
    )
}

PricingDetails.propTypes = {
    order: PropTypes.object,
}

export default PricingDetails
